




















import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { SelectOption, SelectOptionList } from '@/models/api/payment/parameter/type/user-select'
import { Payment } from '@/models/api/payment/payment'
import { ErrorBag } from '@/services/payment/options-validator'
import { CommercePurchaseMenu } from '@spa/services/api/purchase'
import PaymentSelectItem from './PaymentSelectItem.vue'

@Component({
  components: {
    PaymentSelectItem,
  },
})
export default class PaymentSelect extends Vue {
  @Prop({ required: true })
  payments: Payment[]

  @Prop({ required: true })
  selectedPaymentId: string

  @Prop({ required: true })
  selectedPaymentOptions: SelectOptionList

  @Prop({ required: true })
  validation: ErrorBag

  /**
   * NOTE: 再注文時だけ使われる
   * TODO: 美ラボ・ホテラバリリース後すぐにリファクタリングしてこのプロパティを削除する
   * @see: https://github.com/my-color/front/issues/5077
   */
  @Prop({ required: false })
  deliveryMethod: string

  /**
   * NOTE: 再注文時だけ代引き選択に関する注意文言を表示するために使う
   * @see: https://github.com/my-color/front/issues/5077
   */
  @Prop({ required: false, default: null })
  commercePurchaseMenu: CommercePurchaseMenu | null

  /**
   * NOTE: 再注文時だけ使われるロジック
   * 元の注文がネコポス・ポスト投函・置き配の場合は「代引き」不可のため、代引きの選択肢だけdisableにする
   *
   * TODO:
   * /api/user/payment/order/:orderId を配送方法も考慮するように変更し、表示はその結果のみに従うようにする
   * @see: https://github.com/my-color/front/issues/5077
   */
  isDisabled(payment: Payment): boolean {
    if (this.commercePurchaseMenu === null) {
      return false
    }

    for (const method of this.commercePurchaseMenu.deliveryMethod.methods) {
      if (method.name !== this.deliveryMethod) {
        continue
      }

      return payment.id === 'cash-on-delivery'
        && (
          method.arrival_kind === 'posting'
          || method.arrival_kind === 'unattended-delivery'
        )
    }

    return false
  }

  @Emit('select')
  onSelected(_payment: Payment): void {
    // nothing
  }

  @Emit('option-select')
  onOptionSelected(_option: SelectOption) {
    // nothing
  }
}
